import { HHTextField } from '@hinge-health/react-component-library';
import Autocomplete from '@mui/material/Autocomplete';
import { Controller } from 'react-hook-form';
import { capitalizeFirstLetterAndSpaceSnakeString } from '../../utils/bills-utils';
import { BillingTypeFilterProps, StatusFilterLabelText } from './filter-types';

export const BillingTypeFilter = ({
  control,
  billingTypes,
  variant = 'standard',
  label = StatusFilterLabelText.BILL_TYPE,
  loading = false,
  disabled = false,
}: BillingTypeFilterProps): JSX.Element => {
  const billTypesSelectOptions = billingTypes
    .map(type => ({
      value: type.value,
      label: capitalizeFirstLetterAndSpaceSnakeString(type.value),
    }))
    .sort((a, b) => a.value.localeCompare(b.value));

  return (
    <Controller
      control={control}
      name="billingTypes"
      render={({ field: { onChange, value } }): JSX.Element => (
        <Autocomplete
          multiple
          id="billing-types-select"
          options={billTypesSelectOptions}
          disabled={loading || disabled}
          size="small"
          sx={{ minWidth: 230, maxWidth: 230 }}
          limitTags={1}
          blurOnSelect={true}
          onChange={(_, newValue): void => onChange(newValue)}
          value={value}
          getOptionLabel={(option): string => option.label}
          renderInput={(params): JSX.Element => (
            <HHTextField
              {...params}
              hhVariant="variant-bypass"
              variant={variant}
              label={label}
            />
          )}
        />
      )}
    />
  );
};
